import { expandValue } from 'lib/rpcts'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppResourceType } from 'pbts/c1/api/app/v1/app_resource'
import { AppSecretResource, AppSecretResourceView, SearchAppSecretsWithAlertCountResponse } from 'pbts/c1/api/app/v1/app_secret'
import { AppSecretSearchClient } from 'pbts/c1/api/app/v1/app_secret.client'
import { Any } from 'pbts/google/protobuf/any'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'

export interface AppSecretResourceValue extends AppSecretResource {
    app?: App
    appResourceType?: AppResourceType
    alertCount: number
}

export const expandAppSecretResourceView = (msg: AppSecretResourceView | undefined, values: Any[]): AppSecretResourceValue => ({
    ...AppSecretResource.create(msg?.appSecret ?? {}),
    alertCount: msg?.alertCount ?? 0,
    app: expandValue<App>(msg?.appPath, App, values),
    appResourceType: expandValue<AppResourceType>(msg?.resourceTypePath, AppResourceType, values),
})

const transformAppSecretResourceViews = (resp: SearchAppSecretsWithAlertCountResponse): Array<AppSecretResourceValue> => resp.list.map(
    (v): AppSecretResourceValue => expandAppSecretResourceView(v, resp.expanded),
)

export const searchAppSecretsApi = createPagedListApi(
    AppSecretSearchClient,
    'searchAppSecretsWithAlertCount',
    transformAppSecretResourceViews,
)
